<template>
    <div>
        <PageTitleHeader :pageAccessor="'attendeeHeader'" class="py-4">
            <h1
                class="mb-0 title mg-title-header text-center mg-font-bold uppercase"
            >
                {{ textHeader ? textHeader : "ATTENDEE SEACRH" }}
            </h1>
        </PageTitleHeader>

        <section class="container flex flex-col items-center">
            <!-- TODO figure out how to do it -->
            <div v-if="externalAttendeeList" class="w-full pt-12 md:pl-40">
                <a
                    class="text-xl font-semibold"
                    :href="externalAttendeeList"
                    target="_blank"
                    >Click here to view a sortable list of attendees.</a
                >
                <p>
                    Use the search field below to find a specific individual.
                    From the search results (or their profile page) click "Send
                    a Message" to communicate with an attendee.
                </p>
            </div>

            <div class="pt-6 px-4 w-full md:px-40 flex flex-col lg:flex-row">
                <attendee-search-form
                    class="flex flex-col my-4 lg:w-4/6"
                    :profileOwnerId="myOwnProfileId"
                ></attendee-search-form>
                <div
                    class="flex flex-col ml-8 justify-center items-end lg:w-2/6"
                >
                    <a
                        :href="`/attendees/attendee-profile/${myOwnProfileId}`"
                        class="text-white px-6 py-6 font-primary text-base text-center uppercase font-semibold bg-accent mb-0 hover:bg-primary rounded-lg border-l"
                    >
                        View My Profile
                    </a>
                </div>
                <!-- <div v-if="isOwnDataLoaded" class="flex justify-center">
                    <div class="shadow-xl w-3/4 flex flex-col md:flex-row">
                        <div class="border-r border-gray bg-white w-3/6">
                            <img
                                :src="getFullPath()"
                                alt="profile mage"
                                class="w-full h-full"
                            />
                        </div>
                        <div
                            class="w-3/4 bg-white flex flex-col text-body-text"
                        >
                            <div class="flex flex-col px-4 pt-4">
                                <a
                                    href=" "
                                    class="bg-transparent border-0 text-body-text hover:text-accent font-bold text-xl transition-color duration-500 ease-in-out"
                                    >{{ ownProfileInformation.firstName }}
                                    {{ ownProfileInformation.lastName }}</a
                                >
                                <span
                                    class="text-base text-body-text leading-snug border-b pb-2"
                                    >{{ ownProfileInformation.title }}</span
                                >
                            </div>
                            <div class="flex flex-col px-4 py-4 h-24">
                                <span
                                    class="font-semibold is-size-5 text-body-text leading-snug"
                                    >{{
                                        ownProfileInformation.companyName
                                    }}</span
                                >
                            </div>
                            <div class="flex flex-col">
                                <a
                                    :href="
                                        `/attendees/attendee-profile/${ownProfileInformation.attendeeId}`
                                    "
                                    class="text-white font-primary text-lg font-semibold bg-accent mb-0 py-4 text-center"
                                >
                                    View Profile
                                </a>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
            <!-- <div v-else>
                <Spinners />
            </div> -->
        </section>

        <div class="container md:px-4">
            <hr />
        </div>

        <section class="container px-4 my-8">
            <AttendeeSwimLane />
        </section>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { Component, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";

import layoutImagesVuexModule from "@/store/vuex-modules/layoutImages";
import featuredAttendeeVuexModule from "@/store/vuex-modules/getFeaturedAttendees";
import attendeeVuexModule from "@/store/vuex-modules/attendees";

import PageTitleHeader from "@/components/shared/PageTitleHeader.vue";
import AttendeeCard from "@/components/shared/AttendeeCard.vue";
import AttendeeSearchForm from "@/components/attendee-search/AttendeeSearchForm.vue";
import Spinners from "@/components/utilities/Spinners.vue";
import AttendeeSwimLane from "@/components/attendees/swimlanes/AttendeesTaxonomySwimlane.vue";

const featuredAttendeeStore = getModule(featuredAttendeeVuexModule);
const layoutImagesStore = getModule(layoutImagesVuexModule);
const attendeeStore = getModule(attendeeVuexModule);

@Component({
    computed: {
        ...mapGetters(["awsConfig"]),
    },
    components: {
        "attendee-card": AttendeeCard,
        AttendeeSearchForm,
        PageTitleHeader,
        Spinners,
        AttendeeSwimLane,
    },
})
export default class AttendeesTaxonomySampling extends Vue {
    isLoading = true;
    isOwnDataLoaded = false;
    id = "";

    get externalAttendeeList() {
        return this.$store.getters.getPageOptions("attendees")
            .externalAttendeeList;
    }

    get getLayoutOptions() {
        return this.$store.getters.layoutOptions;
    }
    get myOwnProfileId() {
        return this.$store.getters.user.id;
    }

    get layoutImagePagePrimary() {
        return layoutImagesStore.getLayoutImage("pagePrimary");
    }
    get attendeeTaxon() {
        return this.attendeesSwimLane.retailer;
    }
    get attendeesSwimLane() {
        return featuredAttendeeStore.featuredAttendeeByType;
    }

    get attendeeApiOptions() {
        this.id = this.myOwnProfileId;
        const options = { id: this.id, isDemoData: false };
        return options;
    }

    get ownProfileInformation() {
        return attendeeStore.attendee;
    }
    get textHeader() {
        return this.$store.getters.getPageOptions("attendees").textHeader;
    }

    async created() {
        // await attendeeStore.getAttendee(this.attendeeApiOptions).then(() => {
        //     this.isOwnDataLoaded = false;
        // });
    }

    getFullPath() {
        const isDemoData = !this.$store.getters.awsConfig.attendeeTable;
        if (isDemoData)
            return `https://vmpstore.s3.amazonaws.com/images/attendees/${this.imgPath}`;
        else
            return this.imgPath
                ? this.imgPath
                : require("../../assets/avatar.png");
    }
}
</script>
